import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5e4f0fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f5e4f0fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e4f0fa",
  null
  
)

export default component.exports